import React, {useEffect} from 'react';
import {useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "common/hook";
import {
    fetchStudentInfoHomeworks
} from "features/model/service/student-info/students-info-homeworks/featchStudentsInfoHomeworks";
import {NothingYetMessage} from "components/pages/personal-cabinet/nothing-yet-message/NothingYetMessage";
import {Preloader} from "components/layout/preloader/Preloader";
import {StudentsHomeWorksItems} from "./students-home-works-items/StudentsHomeWorksItems";
import {CustomPagination} from "components/pagination/CustomPagination";


export const StudentsHomeWorks = () => {
    const {groupId, studentId} = useParams();
    const dispatch = useAppDispatch()
    const studentHomeworksState = useAppSelector((state) => state.homeworkLessons);
    const {items, isLoading, error} = studentHomeworksState;
    const paginationData = useAppSelector((state) => state.homeworkLessons.pagination);
    const {page, pageSize, pageCount} = paginationData;



    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(fetchStudentInfoHomeworks({groupId, studentId, page: value -1}));
    };


    useEffect(() => {
        dispatch(fetchStudentInfoHomeworks({groupId, studentId}));
    }, [dispatch, groupId, studentId]);


    return (
        <div className="tabs-content">
            <div className="tab">
                <div className="data-tbl individual-student-homework-tbl">
                    <div className="row thead">
                        <div className="col homework-col">Домашнее задание</div>
                        <div className="col lesson-col auto-width">Занятие</div>
                        <div className="col status-col full-width-mobile">Статус</div>
                    </div>
                    {isLoading ? (
                        <Preloader/>
                    ) : items && items.length > 0 ? (
                        items?.map((homework) => (
                            <StudentsHomeWorksItems key={homework.id} homework={homework} studentId={studentId}/>
                        ))
                    ) : (
                        <NothingYetMessage/>
                    )}
                    {pageCount > 1 && (
                        <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle}/>
                    )}
                </div>
            </div>
        </div>
    );
};
